import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'Flexyport'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const flexList = 'Kepegawaian/Flexyport/list/'
export const flexInactive = 'Kepegawaian/Flexyport/inactive/'
export const flexDownloadExcel = 'Kepegawaian/Flexyport/downloadExcel/'
export const flexMasterFilter = 'Kepegawaian/Flexyport/masterFilter/'
export const flexMasterOptions = 'Kepegawaian/Flexyport/masterOptions/'

export const masterRank = 'Master/List/rank/'
export const masterEducation = 'Master/List/education/'
export const masterEducationGroup = 'Master/List/EducationGroup/'
export const masterEchelon = 'Master/List/echelon/'
export const masterPosition = 'Master/List/position/'
export const masterPositionGrade = 'Master/List/positionGrade/'
export const masterWorkUnit = 'Master/List/workUnit/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}